// @flow

// Components
import ScaleGrid from './ScaleGrid'
import RotateGrid from './RotateGrid'
import TranslateGrid from './TranslateGrid'

// Libs
import React, { Component } from 'react'

// Styles
import 'react-input-range/lib/css/index.css'

const styles = {
  container: {
    position: 'absolute',
    right: '-484px',
    padding: '10px 15px',
    margin: '10px 50% 0 0',
    backgroundColor: '#f3f3f3',
    border: '0.5px solid rgb(220, 218, 218)',
    textAlign: 'center',
    zIndex: 999,
  },
  h3: {
    margin: '0 0 0.4em',
    fontSize: '1.1em',
    fontWeight: 400,
    lineHeight: '1.4em',
    letterSpacing: '-0.5px',
  },
  component: {
    display: 'flex',
    fontSize: '14px',
  },
}

type Props = {
  operation: Object,
  gridData: Object,
  selectedFeatureIndices: Array<number>,
  onUpdateGrid: Function
}

// Exports
export class Controls extends Component {
  props: Props
  onChange: Function

  render (): ?React.Element<any> {
    const {
      onUpdateGrid,
      operation,
      selectedFeatureIndices,
      gridData,
    } = this.props
    const key = `tool-for-feature-${selectedFeatureIndices.join('-') || 'common'}`

    return operation ? (
      <div
        style={styles.container}
        key={key}
      >
        <h3 style={styles.h3}>Grid Tools</h3>
        <div style={styles.component}>
          <ScaleGrid
            selectedFeatureIndices={selectedFeatureIndices}
            onChange={onUpdateGrid}
            operation={operation}
          />
          <TranslateGrid
            selectedFeatureIndices={selectedFeatureIndices}
            onChange={onUpdateGrid}
            gridData={gridData}
            operation={operation}
          />
          <RotateGrid
            selectedFeatureIndices={selectedFeatureIndices}
            onChange={onUpdateGrid}
            operation={operation}
          />
        </div>
      </div>
    ) : null
  }
}

export default Controls
